import React from 'react';
import logo from '../../assets/image/logo.png';

const FooterSection = () => {
  return (
    <footer className="relative bg-black overflow-hidden">
      {/* Top Wave Decoration */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-gray-900 to-transparent"></div>

      {/* Footer Bottom */}
      <div className="relative z-10 py-8 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white rounded-xl p-1 shadow-lg">
                <img src={logo} alt="Rushneek Singh" className="w-full h-full object-contain" />
              </div>
              <div>
                <h4 className="text-lg font-bold text-white">Rushneek Singh</h4>
                <p className="text-xs text-gray-500">India's No. 1 B2B Payment Recovery Coach</p>
              </div>
            </div>

            {/* Copyright */}
            <div className="text-center md:text-right">
              <p className="text-gray-500 text-sm">
                © {new Date().getFullYear()} Rushneek Singh. All rights reserved.
              </p>
              <p className="text-gray-600 text-xs mt-1">
                Master Payment Recovery | Transform Your Business
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>
    </footer>
  );
};

export default FooterSection;
